import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Card, CardContent } from '@material-ui/core';
import LifeDetails from '../../components/life-details';
import { setLineOfBusiness } from '../../redux/actions';
import { INSURANCE_PRODUCTS } from '../../../constants';

const Life = ({
  onNextTab,
  onPrevTab,
  currentIndex,
  setLineOfBusiness,
  goToLastTab,
  add,
}: AppComponents.LifeFormProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    setLineOfBusiness(INSURANCE_PRODUCTS[6]);
  }, [setLineOfBusiness]);

  return (
    <>
      <section>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <Card elevation={0} className='applicant-home-form'>
                <CardContent>
                  <LifeDetails
                    onNextTab={onNextTab}
                    onPrevTab={onPrevTab}
                    currentIndex={currentIndex}
                    goToLastTab={goToLastTab}
                    add={add}
                  />
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapDispatchToProps = (dispatch: any): AppComponents.LifeFormDispatch =>
  bindActionCreators({ setLineOfBusiness }, dispatch);

const mapStateToProps = ({ home }: AppComponents.LifeStoreProps) => ({
  home,
});

export default connect(mapStateToProps, mapDispatchToProps)(Life);
